
import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { CONSTANTS } from '../../modules/login/util/constants';
import { CONTENT } from '../header/util/content';
import { APP_CONFIG } from '../services/app-config.service';
import { UserService } from '../services/user.service';

@Component({
  selector: 'app-landing',
  templateUrl: './landing.component.html',
  styleUrl: './landing.component.scss',
  imports: [CommonModule]
})
export class LandingComponent implements OnInit, OnDestroy {
  // The label content for HTML
  content = CONTENT;

  // Error messages
  errorMessage = CONSTANTS.EMPTY;

  private subscription!: Subscription;

  constructor(private userService: UserService, private router: Router) { }

  ngOnInit(): void {
    this.subscription = this.userService.ssoLoginErrorMessage$
      .subscribe((msg: string | null) => {
        if (msg) {
          this.errorMessage = msg;
          this.userService.ssoLoginErrorMessage$.next(null);
        }
      });
  }

  ngOnDestroy(): void {
    this.subscription?.unsubscribe();
  }

  adLogin() {
    if (APP_CONFIG.ENABLE_AZURE_LOGIN !== 'true') {
      this.router.navigate(['/login']);
      return;
    }
    // Use replace() instead of href assignment so /landing is removed from
    // browser history, preventing the back button from returning to this page.
    window.location.replace(APP_CONFIG.DPADMIN_AZURE_SSO_URL);
  }
}
